export function safeScript(input) {
    // transform scripts to native scripts to be executed
    Array.from(input.querySelectorAll('script')).forEach(oldScript => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
    });
    return input;
}
export function elementFromHTML(input) {
    const template = document.createElement('template');
    input = input.trim();
    template.innerHTML = input;
    return template.content.firstChild;
}
export function waitForElm(resolver) {
    return new Promise(resolve => {
        if (resolver()) {
            return resolve(resolver());
        }
        const observer = new MutationObserver(() => {
            if (resolver()) {
                resolve(resolver());
                observer.disconnect();
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    });
}
export function clearNode(node) {
    node.innerHTML = '';
    while (node.firstChild) {
        node.removeChild(node.lastChild);
    }
}
export const escapeScript = (value) => {
    if (typeof value === 'string') {
        return value.replace(/<\/script>/g, '<\\/script>');
    }
    return value;
};
export const restoreScript = (value) => {
    if (typeof value === 'string') {
        return value.replace(/<\\\/script>/g, '<' + '/script>');
    }
    return value;
};
